import { COLOR2, COLOR4, FONT_BOLD_16_18, RADIO_COLOR } from '../../constants';

export const AnotherBankAccountPlaidStyles = {
  text: {
    color: '#FFFFFF',
    font: 'normal 700 12px/normal Arial',
    textTransform: 'uppercase',
    '@media(max-width:600px)': {
      font: 'normal 700 10px/normal Arial',
    },
  },

  textDisable: {
    opacity: '0.5',
    color: '#FFFFFF',
    font: 'normal 700 12px/normal Arial',
    textTransform: 'uppercase',
  },

  textverifySubHead: {
    color: '#444444',
    font: 'normal 400 16px/normal Arial',
    marginTop: '12px',
    marginBottom: '32px',
  },
  bundletextverifysubhead: {
    // marginTop: '12px',
    // marginBottom: '32px',
    margin: '0 !important',
  },
  textVerify: {
    font: 'normal 700 20px / normal TTNormsProBold',
    marginTop: '32px',
  },
  textVerifyBundle: {
    fontWeight: 700,
    marginTop: '24px',
    marginBottom: '13px',
  },

  field_padding_right: {
    paddingRight: '25px',
    '@media(max-width:960px)': {
      paddingRight: '0',
    },
  },

  inputs_grid_margin_another: {
    marginTop: '10px',
    marginBottom: '10px',
    '@media(max-width:950px)': {
      marginTop: '10px',
      marginBottom: '10px',
    },
  },

  accountInfo: {
    color: '#000000',
    marginBottom: '30px',
    font: 'normal 700 24px/18px Arial',
  },

  labelStyle: {
    color: '#444444',
    font: 'normal 700 16px/18px Arial',
  },

  labelValueStyle: {
    font: 'normal 700 16px/normal Arial',
    color: '#000000',
  },

  FailtextYourAcc: {
    color: '#444444',
    font: 'normal 400 16px/normal Arial',
  },

  FailtextTryAgain: {
    color: '#661C69',
    font: 'normal 700 16px/normal Arial',
    textDecorationLine: 'underline',
  },

  VerificationFail: {
    color: '#000000',
    font: 'normal 700 30px/normal Arial',
  },

  gridPadding: {
    padding: '40px 50px !important',
    '@media(max-width:1244px)': {
      padding: '0px 30px 0px 30px',
    },
  },

  pendingContainer: {
    '@media(max-width:600px)': {
      paddingBottom: '15px',
    },
  },

  divLayout: {
    padding: '0 50px',
    height: '100%',
    borderRadius: '4px',
    border: '1px solid #D0D0D0',
    background: '#F8F8F8',
    minHeight: '300px',
    '@media(max-width:1244px)': {
      padding: '0px 30px 0px 30px',
    },
    '@media (min-width:960px) and (max-width:1244px)': {
      // padding: '20px',
    },
    '@media(min-width:1200px)': {
      maxHeight: '350px',
    },
    '@media(max-width:1200px)': {
      maxHeight: '400px',
    },
  },
  divLayoutBundle: {
    padding: '0 50px',
    // borderRadius: '4px',
    // border: '1px solid #D0D0D0',
    // background: '#F8F8F8',
  },

  cardDisabel: {
    opacity: '0.6',
    position: 'relative',
    // paddingRight: '15px',
    '@media(max-width:600px)': {
      paddingRight: '0px',
      // marginBottom: '20px',
      // minHeight: '300px',
    },
  },

  cardEnable: {
    position: 'relative',
    // paddingRight: '15px',
    width: '100%',
    '@media(max-width:600px)': {
      paddingRight: '0px',
      // marginBottom: '20px',
      // minHeight: '300px',
    },
  },

  transistStyle: {
    paddingBottom: '30px',
    borderBottom: '1px solid #E6E6E6',
    marginTop: '10px',
  },

  statementUploadPadding: {
    // paddingLeft: '15px',
    display: 'flex',
    alignItems: 'center',
    '@media(max-width:900px)': {
      paddingLeft: '0px',
    },
  },

  paddingSuccess: {
    marginBottom: '28px',
    '@media(max-width:600px)': {
      marginBottom: '20px',
    },
  },

  paddingSuccessAccType: {
    marginBottom: '0px',
    '@media(max-width:600px)': {
      marginBottom: '20px',
    },
  },

  verfiyFailSpacing: {
    marginTop: '28px',
    marginBottom: '22px',
  },

  weRecommendTextPadding: {
    padding: '7px 14px 7px 14px',
    '@media(max-width:600px)': {
      padding: '7px 11px 7px 11px',
    },
  },

  weRecommendTextStyle: {
    backgroundColor: '#F5821F',
    position: 'absolute',
    right: '1px',
    top: '25px',
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
    '@media(max-width:600px)': {
      right: '0px',
    },
  },
  bundleWeRecommendText: {
    borderRadius: '16px 0 0 0 ',
    position: 'absolute',
    right: '1px',
    top: '20px',
    backgroundColor: '#9747FF',
    padding: '8px 8px 2px 8px',
  },

  paddingFailStatus: {
    paddingRight: '15px',
    '@media(max-width:960px)': {
      paddingRight: 0,
      paddingBottom: '25px',
    },
  },

  VerificationFailSpacing: {
    marginTop: '28px',
    marginBottom: '22px',
    '@media(max-width:600px)': {
      marginTop: '18px',
      marginBottom: '10px',
    },
  },

  successGridPadding: {
    padding: '20px 32px 20px 20px',
  },

  successGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    '@media(max-width:600px)': {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: '10px',
    },
  },

  successGridNew: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    '@media(max-width:600px)': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: '10px',
      marginBottom: '20px',
    },
  },

  allSettextMargin: {
    marginTop: '28px',
    marginBottom: '22px',
  },

  accountInfopadding: {
    padding: '30px',
    backgroundColor: '#FFFFFF',
    '@media(max-width:1244px)': {
      padding: '20px',
    },
    '@media(between(1244,960))': {
      padding: '20px',
    },
  },

  accountInfoGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },

  menuItemMargin: {
    marginBottom: '6px',
  },

  menuItemMarginBottom: {
    marginBottom: '28px',
  },

  depositeSpacing: {
    marginTop: '60px',
    marginBottom: '10px',
  },

  depositeSpacingBorder: {
    marginTop: '60px',
    paddingBottom: '30px',
    borderBottom: '1px solid #E6E6E6',
    '@media(max-width:600)': {
      marginTop: '12px',
      paddingBottom: '30px',
    },
  },

  depositeSpacingBorderOther: {
    marginTop: '60px',
    paddingBottom: '30px',
    borderBottom: '1px solid #E6E6E6',
    '@media(max-width:600px)': {
      marginTop: '30px',
      paddingBottom: '30px',
    },
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  next_continue_button: {
    // border: `1px solid ${RADIO_COLOR}`,
    // background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    color: COLOR4,
    borderRadius: '56px',
    opacity: 1,
    width: '169px',
    height: '48px',
    font: FONT_BOLD_16_18,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media(max-width:600px)': {
      width: '169px',
      height: '48px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },
  next_continue_button_bundle: {
    // border: `1px solid ${RADIO_COLOR}`,
    // background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    color: COLOR4,
    borderRadius: '56px',
    opacity: 1,
    maxWidth: '169px',
    width: '100%',
    height: '32px',
    marginTop: '32px',
    font: FONT_BOLD_16_18,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media(max-width:600px)': {
      width: '169px',
      height: '48px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },
  next_disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '56px',
      fontWeight: 700,
      color: 'rgba(143, 155, 179, 0.5)',
      width: '169px',
      height: '48px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
      '@media(max-width:600px)': {
        width: '169px',
        height: '48px',
      },
    },
  },

  sourceofFunds: {
    paddingLeft: '18px',
  },
  depositHeading: {
    fontSize: '16px',
    fontWeight: 700,
    paddingBottom: '20px',
  },
};
